import { notifications } from "@mantine/notifications"
import { AxiosError } from "axios"

import { queryClient } from "~/backend/queryClient"
import {
  findSupplierMappingQueryKey,
  useCreateSupplierMappingByEmail,
} from "~/gen/api/hooks"

export const useCreateSupplierMappingByEmailMutation = ({
  searchSupplier,
}: {
  searchSupplier: string
}) =>
  useCreateSupplierMappingByEmail({
    mutation: {
      onSuccess: async (data) => {
        if (data) {
          await queryClient.invalidateQueries(
            findSupplierMappingQueryKey({
              searchSupplier,
            })
          )
        }
      },
      onError: (error) => {
        if (error instanceof AxiosError) {
          notifications.show({
            title: "Supplier create error",
            message:
              "Supplier create failed : " + error.response?.data?.message,
            color: "red",
          })
        }
      },
    },
  })
